module.exports = __webpack_public_path__ + "img/Victorinox Swiss Army Classic SD Pocket Knife.2b3a31ec.jpg";